import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.xsquarehub.com/api',
});

function handleForcedLogout(redirectPath = '/login') {
  try {
    window.dispatchEvent(new Event('auth:unauthorized'));
  } catch {
    // Ignore environments where custom events fail
  }

  try {
    localStorage.clear();
  } catch {
    // Ignore restricted storage environments
  }

  if (window.__reactRouterNavigate) {
    window.__reactRouterNavigate(redirectPath);
  } else {
    window.location.href = redirectPath;
  }
}

// Attach token to every request
api.interceptors.request.use(
  config => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // Ignore storage access issues
    }
    return config;
  },
  error => Promise.reject(error)
);

// Global response error handler
api.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    const url = err.config?.url || '';
    const isAuthRoute = url.includes('/auth/login') || url.includes('/auth/register');

    // Any 401 (invalid/expired token) except login/register/logout — force logout
    if (status === 401 && !isAuthRoute) {
      let hasToken = false;
      try {
        hasToken = Boolean(localStorage.getItem('token'));
      } catch {
        hasToken = false;
      }

      if (hasToken) {
        handleForcedLogout('/login');
      }
    }

    // 403 on profile — account disabled, force logout
    if (status === 403 && url.includes('/auth/profile')) {
      handleForcedLogout('/login');
    }

    return Promise.reject(err);
  }
);

export default api;
